<div class="relative flex h-full flex-col gap-8 p-5">
  <pl-icon
    *ngIf="isLifemapLogsFullySyncedWithServer()"
    [name]="PlIcon.verified"
    class="absolute right-2 top-2 z-10 h-12 w-12 text-pl-orange-500"
  />

  <h2 class="mb-4 font-sans text-pl-gray-500">
    {{ 'lifemap.modal_completed_lifemap.title' | translate }}
  </h2>

  <div [ngSwitch]="sectionToDisplay()" class="flex flex-col gap-8">
    <div *ngSwitchCase="Section.loading" class="flex h-64 w-full items-center justify-center">
      <pl-loader />
    </div>

    <ng-container *ngSwitchCase="Section.stepCompletedLifemapComplete">
      <div class="flex grow flex-col gap-4">
        <p class="pl-inner-html text-lg" [innerHTML]="lifemapBlock().data.config.stepCompleted.title"></p>
        <p
          *ngFor="let content of lifemapBlock().data.config.stepCompleted.text"
          class="text-lg"
          [innerHTML]="content"
        ></p>
      </div>
      <div class="flex justify-end gap-4">
        <pl-button
          class="!w-fit"
          [padding]="ButtonPadding.big"
          [variant]="ButtonVariant.lightOrange"
          (click)="goToCurrentStep()"
        >
          {{ lifemapBlock().data.config.continueButtonLabel }}
        </pl-button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="Section.stepCompletedLifemapIncomplete">
      <div class="flex grow flex-col gap-4">
        <p class="text-lg">{{ 'lifemap.modal_completed_lifemap.step_completed_but_not_lifemap.body1' | translate }}</p>
        <p class="text-lg">{{ 'lifemap.modal_completed_lifemap.step_completed_but_not_lifemap.body2' | translate }}</p>
      </div>
      <div class="flex justify-end gap-8">
        <pl-button
          class="!w-fit"
          [padding]="ButtonPadding.big"
          [variant]="ButtonVariant.white"
          (click)="contactSupport()"
        >
          {{ 'lifemap.modal_completed_lifemap.sync_issue.contact_us' | translate }}
        </pl-button>
        <pl-button
          class="!w-fit"
          [padding]="ButtonPadding.big"
          [variant]="ButtonVariant.lightOrange"
          (click)="goToCurrentStep()"
        >
          {{ lifemapBlock().data.config.continueButtonLabel }}
        </pl-button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="Section.submitLifemap">
      <div class="flex grow flex-col gap-4">
        <p class="pl-inner-html text-lg" [innerHTML]="lifemapBlock().data.config.finishLifeMap.title"></p>
        <p class="pl-inner-html text-lg" [innerHTML]="lifemapBlock().data.config.finishLifeMap.subTitle"></p>
        <p class="text-lg font-bold">{{ 'lifemap.modal_completed_lifemap.please_note' | translate }}</p>
      </div>
      <div class="flex justify-end gap-4">
        <pl-button class="!w-fit" [padding]="ButtonPadding.big" [variant]="ButtonVariant.white" (click)="closeModal()">
          {{ 'utils.dismiss' | translate }}
        </pl-button>
        <pl-button
          class="!w-fit"
          [padding]="ButtonPadding.big"
          [variant]="ButtonVariant.lightOrange"
          (click)="submitLifemap()"
        >
          {{ 'lifemap.modal_completed_lifemap.submit_lifemap' | translate }}
        </pl-button>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="Section.synchronisationIssues">
      <pl-icon
        [frame]="IconFrame.round"
        [name]="PlIcon.close"
        (click)="closeModal()"
        class="absolute right-2 top-2 z-10 h-12 w-12 cursor-pointer border-transparent bg-transparent text-pl-gray-700 hover:bg-pl-gray-200"
      />
      <div class="flex grow flex-col gap-4">
        <p class="text-lg">
          {{ 'lifemap.modal_completed_lifemap.sync_issue.body1' | translate }}
        </p>
        <p class="text-lg">{{ 'lifemap.modal_completed_lifemap.sync_issue.body2' | translate }}</p>
      </div>
      <div class="flex justify-end gap-8">
        <pl-button
          class="!w-fit"
          [padding]="ButtonPadding.big"
          [variant]="ButtonVariant.white"
          (click)="syncDataWithServer()"
        >
          {{ 'lifemap.modal_completed_lifemap.sync_issue.sync_data' | translate }}
        </pl-button>
        <pl-button
          class="!w-fit"
          [padding]="ButtonPadding.big"
          [variant]="ButtonVariant.white"
          (click)="contactSupport()"
        >
          {{ 'lifemap.modal_completed_lifemap.sync_issue.contact_us' | translate }}
        </pl-button>
      </div>
    </ng-container>
  </div>
</div>
